import { Pipe, PipeTransform } from '@angular/core';
import { LanguageOption } from './toolbar.types';

@Pipe({
    name: 'languageFlag',
    standalone: false
})
export class LanguageFlagPipe implements PipeTransform {
    transform(langCode: string, languages: LanguageOption[]): string {
        const found = languages?.find(l => l.code === langCode);
        return found?.flagCode ?? 'un';
    }
}
